module.exports = __webpack_public_path__ + "img/file-download.4b33e9e4.svg";